<!------------ START TEMPLATE ------------>
<template>
  <div style="width: 100%">
    <!------------ START FORM ------------>
    <vs-card class="mb-6">
      <form role="form" @submit.stop.prevent="buscar">
        <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo usuário na parte cadastro de Status do Menu USUARIO  ==================------->

        <div class="vx-row pb-2">
          <div class="vx-col sm:w-1/4 w-full">
            <span>Lançamento</span>
            <v-select
              :options="tipoTransacao"
              name="tipoTransacao"
              id="tipoTransacao"
              v-model="formFiltro.tipoTransacao"
              :state="validateState('Status')"
              :class="validateClass('Status')"
            ></v-select>
          </div>
          <div class="vx-col sm:w-1/4 w-full">
            <span>Data Inicial</span>
            <datepicker
              :format="'dd/MM/yyyy'"
              placeholder="DD/MM/YYYY"
              v-model="formFiltro.dataInicial"
            ></datepicker>
          </div>
          <div class="vx-col sm:w-1/4 w-full">
            <span>DataFinal</span>
            <datepicker
              :format="'dd/MM/yyyy'"
              placeholder="DD/MM/YYYY"
              v-model="formFiltro.dataFinal"
            ></datepicker>
          </div>
        </div>
      </form>
      <div slot="footer" style="margin-top: -3%">
        <br style="clear: both" />
        <vs-row vs-justify="flex-end">
          <vs-button
            color="success"
            type="filled"
            icon-pack="feather"
            icon="icon-search"
            class="mr-3 mb-2"
            @click="buscar"
            >Buscar</vs-button
          >
          <vs-button
            @click="limparFiltro"
            color="danger"
            type="gradient"
            icon-pack="feather"
            icon="icon-trash-2"
          ></vs-button>
        </vs-row>
      </div>
    </vs-card>
    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import locale from './../../locale';
import Datepicker from 'vuejs-datepicker';
import * as lang from 'vuejs-datepicker/src/locale';
import vSelect from 'vue-select';
import service from '../../services';
import jwt from 'jsonwebtoken';

export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
    vistoria: {
      type: Boolean,
    },
  },
  watch: {},
  data() {
    return {
      aguardeCadastro: false,
      idEmpresa: null,
      estados: [],
      regionais: [],
      tipoTransacao: [],
      languages: lang,
      filtroAvancado: false,
      tiposEvento: [],
      estado: null,
      funcoesValicao: null,
      usuarios_regionais: [],
      regionalDefault: [],
      regionaisUsuario: [],
      formFiltro: {
        idEmpresa: null,
        tipoTransacao: null,
        dataInicial: this.dataInicio(),
        dataFinal: new Date(),
      },
    };
  },
  methods: {
    limparFiltro() {
      this.formFiltro = {
        tipoTransacao: null,
        dataInicial: this.dataInicio(),
        dataFinal: new Date(),
      };
      this.buscar();
    },
    getDecoded() {
      const token = localStorage.getItem('user-token');
      if (token) {
        this.decoded = jwt.decode(token);
      }
      this.id_usuario = this.decoded.id_usuario;
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data.forEach((element) => {
          this[array].push({
            id: element[campoPK],
            label: element[campoDescricao],
          });
        });
      });
    },
    buscar() {
      this.formFiltro.idEmpresa = this.idEmpresa;
      this.formFiltro.filtred = true;
      this.$emit('filtro', this.formFiltro);
    },
    dataInicio() {
      var a = new Date();
      var b = a.setDate(a.getDate() - 1);
      return b;
    },
  },
  mounted() {
    this.getDecoded();
    this.buscaDadosSelects(
      'TipoTransacao',
      'tipoTransacao',
      'descricao',
      'idTipoTransacao',
    );
    //this.buscaDadosSelects("domMunicipio", "cidades", "nomeCidade", "idCidade");
    this.$validator.localize('ptBr', locale);
  },
  components: {
    Datepicker,
    'v-select': vSelect,
  },
};
</script>
<!------------ END SCRIPT ------------>
<style>
.vs__dropdown-toggle {
  padding: 4px 0 6px 0 !important;
}

input.flatpickr-input {
  width: 100%;
}

.vdp-datepicker input {
  width: 100%;
}

.vdp-datepicker__calendar {
  z-index: 900 !important;
}
</style>
